
















































import Vue from 'vue'
import Option from '../assessments/Option.vue'
export default Vue.extend({
  components: {
    Option
  },
  props: {
    index: {
      type: Number
    },
    questionType: {
      type: String,
      default: "single"
    },
    questionTitle: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    questionLength: {
      type: Number
    },
    sequenceNumber: {
      type: Number
    },
    questionId: {
      type: String
    },
    showingResults: {
      type: Boolean
    },
    correctAnswerGiven: {
      type: Boolean
    },
    questionExplanation: {
      type: String
    },
    requiredPassingGrade: {
      type: Boolean
    }
  },
  mounted() {
    this.optionList = this.options.map(e => {
      return {
        isCorrect: e.isCorrect,
        isSelected: e.isSelected,
        sequence: e.sequence,
        statement: e.statement
      }
    })
  },
  data() {
    return {
      optionList: [],
    }
  },
  methods: {
    selectAnswer(sequenceNumber: number) {
      this.optionList[sequenceNumber - 1].isSelected = true
      if (this.questionType === 'single') {
        this.optionList.forEach((e, index) => {
          if (index !== sequenceNumber - 1) {
            e.isSelected = false
          }
        })
      }
      this.$emit('updateQuizResponse', {
        selected: sequenceNumber,
        questionSequenceNumber: this.sequenceNumber,
        questionId: this.questionId
      })
    },
    unselectAnswer(sequenceNumber: number) {
      this.optionList[sequenceNumber - 1].isSelected = false
      this.$emit('removeQuizResponse', {
        toUnselect: sequenceNumber,
        questionSequenceNumber: this.sequenceNumber
      })
    }
  },
  computed: {
    correctOptionNotAvailable(): boolean {
      return this.options.filter(e => e.isCorrect).length === 0
    },
    correctOptions(): string[] {
      return this.options.filter(e => e.isCorrect).map(e => `'${String.fromCharCode(96 + e.sequence).toUpperCase()}'`)
    },
    loadedOptionList() {
      return this.showingResults ? this.options : this.optionList
    }
  }
})
